/// <reference path="../factories/blocks.logger.factory.ts"/>
/// <reference path="../providers/blocks.exception.provider.ts"/>
/// <reference path="../factories/blocks.router.factory.ts"/>
/// <reference path="blocks.storage.module.ts" />

module App.Core {
    export interface IAppCore extends ng.IModule { }

    export class AppCore {
        static moduleId = 'app.core';
    }

    // Create the module and define its dependencies.
    export var appCore: IAppCore = angular.module(AppCore.moduleId, [
        // Angular modules 

        // Custom modules 
        Blocks.Storage.moduleId,
        Blocks.Logger.moduleId,
        Blocks.Exception.moduleId,
        Blocks.Router.moduleId,

        // 3rd Party Modules
    ]);
}